// import { SplitText } from 'gsap/SplitText';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Snap from "./useSnap";
import utils from '../utils';
const { isMobile } = utils;

gsap.registerPlugin( ScrollTrigger );

class Hero {
  constructor({ holder }) {
    this.holder = holder;
  }

  initAnimation() {
    this.animation = gsap.timeline({ paused: true });

    if( $( window ).width() <= 1024 ) {
      var movingObject = [
        document.querySelector( ".hero-video .container .copy" ),
        document.querySelector( ".hero-video .hero-illustrator" )
      ];
    } else {
      var movingObject = document.querySelector( ".hero-video .container .copy" );
      
    }

    this.animation.to( [ document.querySelector( "#hero .powered" ), document.querySelector( "#hero .action" ) ], {
      opacity: 0,
      duration: 0.1,
      ease: "linear"
    }, '0' ).to( movingObject, {
      y: -700,
      opacity: 0,
      duration: 0.5,
      ease: "linear"
    }, '0' );

    const animationTrigger = ScrollTrigger.create({
        scroller: "[data-scroll-container]",
        trigger: document.querySelector("#hero"),
        animation: this.animation,
        scrub: 0,
        start: "top top",
        end: "bottom bottom",
        pin: false,
        pinSpacing: false,
        markers: false
    } );

    this.initSnap();
    // isMobile ? this.initSnapMobile() : this.initSnap();
  }

  initSnap() {
    this.snap = new Snap({
      element: document.querySelector('.hero'),
      goToPoint: (point, duration, index, pointElem) => {
        
      },
      duration: 0.1,
      hasPin: false,
      stickOnInit: true
    });

    this.snap.init();
  }

  initSnapMobile() {
    // document.querySelector('.hero-video-holder').removeAttribute('data-scroll-sticky');
    $(this.holder).find('.hero-video-holder').addClass('-static');
    lscroll.update();

    const animationTrigger1 = ScrollTrigger.create({
      scroller: "[data-scroll-container]",
      trigger: document.querySelector('[data-mobile-snap]'),
      scrub: 0,
      start: "top top",
      end: "bottom bottom",
      // onUpdate: self => console.log("progress", self.progress),
      pin: document.querySelector('.preloader'),
      onLeave: () => {
        gsap.to(document.querySelector('.hero .hero_scroll'), {
          duration:0.3,
          opacity: 0
        })
      },
      onEnterBack: () => {
        gsap.to(document.querySelector('.hero .hero_scroll'), {
          duration:0.3,
          opacity: 1
        })
      },
      pinSpacing: false,
      markers: false,
    });

    const animationTrigger = ScrollTrigger.create({
      scroller: "[data-scroll-container]",
      trigger: document.querySelector("#hero"),
      scrub: 0,
      start: "top top",
      end: "bottom bottom",
      // onUpdate: self => console.log("progress", self.progress),
      // pin: document.querySelectorAll('.hero-content-wrap'),
      pinSpacing: false,
      markers: false,
    });

    const animationTrigger3 = ScrollTrigger.create({
      scroller: "[data-scroll-container]",
      trigger: document.querySelector("#hero"),
      scrub: 0,
      start: "top top",
      end: "bottom bottom",
      // onUpdate: self => console.log("progress", self.progress),
      // pin: document.querySelectorAll('.hero-bg'),
      pinSpacing: false,
      markers: false,
    });

    // this.snap = new Snap({
    //   element: document.querySelector('[data-mobile-snap]'),
    //   goToPoint: (point, duration, index, pointElem,) => {
        
    //   },
    //   hasPin: false,
    //   stickOnInit: true,
    //   mobileOffset: -60
    // });

    // this.snap.init();
  }

    init() {
        document.addEventListener( "preloaderDone", ( e ) => {
            this.preloaderAnim = e.detail.preloaderAnim;
            this.endFrame = e.detail.endFrame;

            this.initAnimation();
        }, { once: true } );
    }
}

export default function () {
    document.querySelectorAll( "[data-hero]" ).forEach( ( holder, i ) => {
        let hero = new Hero({ holder });
        hero.init();
    } );
}